import { useEffect } from 'react'
import { X } from 'lucide-react'

/**
 * Convierte cualquier URL de YouTube (watch, youtu.be o embed) a forma embebible.
 */
function toEmbedUrl(url: string): string {
  if (!url) return ''
  try {
    if (url.includes('/embed/')) return url
    const u = new URL(url)
    if (u.hostname.includes('youtu.be')) {
      return `https://www.youtube.com/embed/${u.pathname.slice(1)}`
    }
    const v = u.searchParams.get('v')
    if (v) return `https://www.youtube.com/embed/${v}`
    return url
  } catch {
    return url
  }
}

/**
 * Modal a pantalla completa con un video de YouTube embebido. Lo usa el botón
 * "Ver demo" del Hero. Cierra con la X o con Escape.
 */
export function VideoModal({
  open,
  url,
  onClose,
}: {
  open: boolean
  url: string
  onClose: () => void
}) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null
  const embed = toEmbedUrl(url)

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        aria-label="Cerrar"
        className="absolute right-5 top-5 grid size-11 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20"
      >
        <X className="size-6" />
      </button>
      <div className="w-full max-w-5xl aspect-video" onClick={(e) => e.stopPropagation()}>
        {embed ? (
          <iframe
            className="h-full w-full rounded-xl"
            src={`${embed}?autoplay=1`}
            title="Demo TecoPOS"
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
            allowFullScreen
          />
        ) : (
          <div className="grid h-full w-full place-items-center rounded-xl bg-neutral-900 text-neutral-400">
            No hay video configurado.
          </div>
        )}
      </div>
    </div>
  )
}
